import { defineStore } from 'pinia';
import { computed } from 'vue';

import { useAuthSessionStore } from '../auth0/store/auth-session.store';

import type { IfState } from './access-control.types';

export const useIfSourceStore = defineStore('if-source', () => {
  const authSessionStore = useAuthSessionStore();

  const ifSource = computed<IfState>(() => {
    return {
      data: authSessionStore.jwtToken
        ? {
            isAuthenticated: authSessionStore.isAuthenticatedInIf,
            ifExternalUserId: authSessionStore.ifExternalUserId,
            ifClientId: authSessionStore.ifClientId,
          }
        : null,
      status: authSessionStore.jwtToken ? 'loaded' : 'idle',
    };
  });

  const isIfSatisfied = computed(() => {
    return ifSource.value.data?.isAuthenticated ?? false;
  });

  return {
    ifSource,
    isIfSatisfied,
  };
});
